import { Button } from "@adfenix/alexandria";

interface Props {
  isToggled: boolean;
  setToggle: (toggled: boolean) => void;
  toggledMessage: string;
  toggleMessage: string;
  disabled?: boolean;
}

export const ToggleButton = ({
  toggleMessage,
  toggledMessage,
  isToggled,
  setToggle,
  disabled
}: Props) => {
  return (
    <Button
      logLabel="toggle-template-info-button"
      variant="text"
      onClick={() => setToggle(!isToggled)}
      disabled={disabled ?? false}
    >
      <i
        className={
          isToggled
            ? "uil uil-times"
            : toggleMessage === "Switch"
            ? "uil uil-arrow-random"
            : "uil uil-plus"
        }
      />
      {isToggled ? toggledMessage : toggleMessage}
    </Button>
  );
};
